module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segments"
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui breadcrumb"
  }, [_c('router-link', {
    staticClass: "section",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Sākums")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("/")]), _vm._v(" "), _c('div', {
    staticClass: "active section"
  }, [_vm._v("Pirkumu grozs")])], 1)]), _vm._v(" "), _c('cart-steps', {
    attrs: {
      "step": "3",
      "confirmed": _vm.order && _vm.order.status
    }
  }), _vm._v(" "), (_vm.order) ? _c('div', {
    staticClass: "ui attached segment"
  }, [(_vm.order.paysera_stat == 2) ? _c('div', {
    staticClass: "ui warning icon message"
  }, [_c('i', {
    staticClass: "info circle icon"
  }), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Paldies par pasūtījumu!")]), _vm._v(" "), (!_vm.order.only_services) ? _c('p', [_vm._v("Jūsu pasūtījumu plānots piegādāt "), _c('b', [_vm._v(_vm._s(_vm.order.delivery_date))]), _vm._v(" uz:\n\n    "), _c('b', [_vm._v(_vm._s(_vm.order.address))])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), (!_vm.order.only_services) ? _c('p', [_vm._v("Piegādes pavaddokuments tiks nosūtīts uz jūsu e-pastu piegādes brīdī.")]) : _vm._e(), _vm._v(" "), (!_vm.order.only_services && _vm.order.payment_type == 3) ? _c('p', [_vm._v("Lūdzu atstājiet kurjeram iespējami precīzu naudu -\n    "), (!_vm.order.only_services && _vm.user.balance < 0) ? _c('b', [_vm._v(_vm._s(_vm.positiveBalance))]) : _vm._e(), _vm._v(" "), (!_vm.order.only_services && _vm.user.balance >= 0) ? _c('b', [_vm._v(_vm._s(_vm.order.total_amount_with_bail_and_vat))]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v("€")])]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "f",
      rawName: "v-f",
      value: (_vm.order.bonus > 0),
      expression: "order.bonus > 0"
    }],
    staticStyle: {
      "color": "#21BA45"
    }
  }, [_vm._v("Jūs izmantojāt savu uzkrāto bonusu citu produktu iegādei EUR " + _vm._s(_vm.order.bonus) + ". Maksimāli bonusu var izmantot 30% apmērā no citu produktu summas.")]), _vm._v(" "), _c('div', {
    staticClass: "ui container"
  }, [_c('button', {
    staticClass: "ui right floated custom_brown button",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'goods'
        })
      }
    }
  }, [_vm._v("Izveidot jaunu pasūtījumu")]), _vm._v(" "), _c('div', {
    staticClass: "ui clearing hidden divider"
  })])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n          Informācijai\n        ")]), _vm._v(" "), _c('p', [_vm._v("Samaksas process vēl nav galīgi pabeigts. Atkarībā no bankas parasti šis process aizņem dažas stundas. "), _c('br'), _vm._v(" Tiklīdz samaksa tiks saņemta, Jūs saņemsiet e-pastu no maksājumu sistēmas un Jūsu veiktais pasūtījums būs apskatāms sadaļā \"Gaida piegādi\".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Ja rodas steidzami jautājumi, sazinieties ar pasūtījumu centru pa tel. "), _c('a', {
    attrs: {
      "href": "tel:0037120010800<"
    }
  }, [_vm._v("200 108 00")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-434bb1f3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartConfirmationPage.vue
// module id = 340
// module chunks = 1